import { render, staticRenderFns } from "./SwitchList.vue?vue&type=template&id=3ec96dd6&scoped=true&"
import script from "./SwitchList.vue?vue&type=script&lang=js&"
export * from "./SwitchList.vue?vue&type=script&lang=js&"
import style0 from "./SwitchList.vue?vue&type=style&index=0&id=3ec96dd6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ec96dd6",
  null
  
)

export default component.exports